import { Page } from '@ih/app/shared/apis/interfaces';

export class SetPagesAction {
  public static readonly type = '[Project/Wiki/List] SetPagesAction';
  constructor(public readonly pages: Page[]) {}
}
